import {
  FlowContentNodeSchema,
  ProcedureSchema,
} from "@redotech/redo-procedures-common/markdown-flow/index";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const saveProcedure = {
  name: "saveProcedure" as const,
  input: z.object({
    procedureId: zExt.objectId().optional(),
    name: z.string(),
    content: z.array(FlowContentNodeSchema),
    enabled: z.boolean().optional(),
  }),
  output: z.object({ procedure: ProcedureSchema }),
};
